import { HTTP, authHeader } from './http-service';

class GuaranteeClaimSearchService {
  search(payload) {
    return HTTP.post(`/GuaranteePolicyClaimSearch`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }

  advancedSearch(payload) {
    return HTTP.post(`/GuaranteePolicyClaimSearch/advance`, payload, {
      headers: authHeader(),
    }).then((response) => {
      return response.data;
    });
  }
}

export default new GuaranteeClaimSearchService();
